"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthEvent = void 0;
var AuthEvent;
(function (AuthEvent) {
    AuthEvent["Authenticated"] = "authenticated";
    AuthEvent["NeedUpdateUserData"] = "needUpdateUserData";
    AuthEvent["NeedClearUserData"] = "needClearUserData";
    AuthEvent["AuthWasCancelled"] = "authWasCancelled";
    AuthEvent["AccessTokenWasRefreshed"] = "accessTokenWasRefreshed";
})(AuthEvent || (exports.AuthEvent = AuthEvent = {}));
